import { Chip, Grid, Stack, Tooltip, Typography } from '@mui/material';
import MUIDataTable from 'mui-datatables';
import * as React from 'react';
import * as Redux from 'react-redux';
import * as CONST from '../../../../constants/FieldsConst';
import { textLabels } from '../../../../helpers';
import { useNotification } from '../../../../helpers/Notification';
import { LoadingWidget } from '../../../../widgets';
import ActionsListWidget from '../../../../widgets/ActionsList';
import DeleteModalComponent from '../../../../widgets/modals/DeleteModal';
import { allEntCarrerasAction } from '../../../entidad/ent_carreras/EntCarrerasAction';
import { allEntNivelesAcademicosAction } from '../../../entidad/ent_niveles_academicos/EntNivelesAcademicosAction';
import { NameComponent } from '../../../usuario/usuarios/components/ListadoUsuarios';
import {
  allAularioAction,
  deleteAularioAction,
  setActivoAularioAction,
} from '../AularioAction';
import ExpandedAularioComponent from './ExpandedAulario';

const ListadoAulario = ({ setOpenModalForm }) => {
  const dispatch = Redux.useDispatch();
  const { notify } = useNotification();

  const loginStore = Redux.useSelector((state) => state.login);
  const entidadesStore = Redux.useSelector((state) => state.entidades);
  const aularioStore = Redux.useSelector((state) => state.aulario);
  const entNivelesAcademicosStore = Redux.useSelector(
    (state) => state.entNivelesAcademicos,
  );
  const entCarrerasStore = Redux.useSelector((state) => state.entCarreras);

  const [loadingDelete, setLoadingDelete] = React.useState(false);
  const [openModalDelete, setOpenModalDelete] = React.useState(false);
  const [rows, setRows] = React.useState([]);

  React.useEffect(() => {
    const fetchData = async () => {
      if (
        entNivelesAcademicosStore.all &&
        entNivelesAcademicosStore.all.length === 0
      ) {
        await allEntNivelesAcademicosAction(dispatch, {
          idEntidad: entidadesStore.activo.id,
        });
      }
      if (entCarrerasStore.all && entCarrerasStore.all.length === 0) {
        await allEntCarrerasAction(dispatch, {
          idEntidad: entidadesStore.activo.id,
        });
      }

      const payload = {
        ...aularioStore.params,
        idEntidad: entidadesStore.activo.id,
      };
      if (aularioStore.all && aularioStore.all.length === 0) {
        allAularioAction(dispatch, payload);
      }
    };
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  React.useEffect(() => {
    const rowsData = [];
    aularioStore.all.forEach((el) => {
      rowsData.push({
        ...el,
        estatus: el.estatus.nombre,
      });
    });
    setRows(rowsData);
  }, [aularioStore.all]);

  const _handleEditClick = async (id) => {
    const data = aularioStore.all.find((el) => el.id === id);
    await setActivoAularioAction(dispatch, data);
    setOpenModalForm(true);
  };

  async function _onDeleteHandler() {
    setLoadingDelete(true);
    await deleteAularioAction(
      { dispatch, notify },
      aularioStore.activo.id,
      aularioStore.params,
    );
    setOpenModalDelete(false);
    setLoadingDelete(false);
  }

  const columns = [
    {
      name: CONST.ID,
      options: {
        display: loginStore.isRoot ? false : 'excluded',
        filter: false,
      },
    },
    {
      name: CONST.nombre.name,
      label: CONST.aula.label,
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <NameComponent
              onClick={() => _handleEditClick(tableMeta.rowData[0])}
            >
              {value}
            </NameComponent>
          );
        },
      },
    },
    {
      name: CONST.numero.name,
      label: CONST.numero.label,
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: CONST.capacidad.name,
      label: CONST.capacidad.label,
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: CONST.isAbierto.name,
      label: CONST.isAbierto.quest,
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <Typography variant="body1" color="initial">
              {value ? 'Si' : 'No'}
            </Typography>
          );
        },
      },
    },
    {
      name: CONST.isOperativo.name,
      label: CONST.isOperativo.quest,
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <Typography variant="body1" color="initial">
              {value ? 'Si' : 'No'}
            </Typography>
          );
        },
      },
    },
    {
      name: CONST.estatus.name,
      label: CONST.estatus.label,
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <Tooltip
              describeChild
              title="Estatus del registro"
              placement="left"
            >
              <Chip
                label={value}
                size="small"
                color={value === 'ACTIVO' ? 'success' : 'error'}
              />
            </Tooltip>
          );
        },
      },
    },
    {
      name: CONST.actions.name,
      label: CONST.actions.label,
      options: {
        filter: false,
        sort: false,
        empty: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <Stack direction="row">
              <ActionsListWidget
                id={tableMeta.rowData[0]}
                onEdit={() => _handleEditClick(tableMeta.rowData[0])}
                onDelete={() => {
                  const data = aularioStore.all.find(
                    (el) => el.id === tableMeta.rowData[0],
                  );
                  setActivoAularioAction(dispatch, data);
                  setOpenModalDelete(true);
                }}
                onDownload={() => {
                  window.open(value.url);
                }}
              />
            </Stack>
          );
        },
      },
    },
  ];

  const options = {
    filterType: 'dropdown',
    responsive: 'scroll',
    setTableProps: () => {
      return {
        padding: 'none',
        size: 'small',
      };
    },
    rowsPerPage: 25,
    rowsPerPageOptions: [25, 50, 100],
    print: false,
    download: false,
    textLabels,
    selectableRowsHideCheckboxes: true,
    expandableRows: true,
    renderExpandableRow: (rowData, rowMeta) => {
      const data = aularioStore.all.find((el) => el.id === rowData[0]);
      return <ExpandedAularioComponent data={data} rowData={rowData} />;
    },
  };

  return (
    <Grid container>
      <Grid item md={12}>
        <LoadingWidget isLoading={aularioStore.loadingAll || loadingDelete} />
        <MUIDataTable
          title="Listado"
          data={rows}
          columns={columns}
          options={options}
        />
      </Grid>
      {aularioStore.activo && (
        <DeleteModalComponent
          open={openModalDelete}
          onClose={() => setOpenModalDelete(!openModalDelete)}
          onDelete={_onDeleteHandler}
        >
          <Typography variant="h6">{aularioStore.activo.nombre}</Typography>
        </DeleteModalComponent>
      )}
    </Grid>
  );
};

export default ListadoAulario;
